import { Attachment, AttachmentStatus } from '@eika/file-uploader';

import { FileInfo, VedleggStatus, VedleggWithFile } from '../../sporsmalsflyt/filopplasting/filopplasting-types';

export interface InternalAttachment {
    internalId?: string;
    fileName: string;
    uploadId: string;
    fileInfo: FileInfo;
    url: string;
    size?: number;
}

const fromAttachmentStatusToVedleggStatus = (attachmentStatus: AttachmentStatus): VedleggStatus => {
    switch (attachmentStatus) {
        case AttachmentStatus.Ok:
            return VedleggStatus.Ok;
        case AttachmentStatus.Uploading:
            return VedleggStatus.Uploading;
        case AttachmentStatus.ErrorTotalFileSize:
            return VedleggStatus.ErrorTotalFileSize;
        case AttachmentStatus.Error:
        default:
            return VedleggStatus.Error;
    }
};

export const fromAttachmentToInternalAttachment = (attachment: Attachment): InternalAttachment => ({
    internalId: undefined,
    fileName: attachment.fileName,
    uploadId: attachment.id,
    fileInfo: { name: attachment.file.name, type: attachment.file.type, size: attachment.file.size },
    url: attachment.url,
    size: attachment.size,
});

export const toInternalAttachments = (vedlegg: VedleggWithFile[], attachments: Attachment[]): InternalAttachment[] => {
    return vedlegg.map((vedleggUploaded) => {
        const currentAttachment = attachments.find((attachment) => attachment.id === vedleggUploaded.uploadId);
        return {
            internalId: vedleggUploaded.id,
            fileName: currentAttachment.fileName,
            uploadId: currentAttachment.id,
            fileInfo: {
                name: currentAttachment.file.name,
                type: currentAttachment.file.type,
                size: currentAttachment.file.size,
            },
            url: currentAttachment.url,
            size: currentAttachment.size,
        };
    });
};

export const fromAttachmentToVedleggWithFile = (attachments: Attachment[]): VedleggWithFile[] =>
    attachments.map((attachment) => ({
        uploadId: attachment.id,
        fil: attachment.file,
        url: attachment.url,
        size: attachment.size,
        status: fromAttachmentStatusToVedleggStatus(attachment.status),
        fileName: attachment.fileName,
    }));
